<div *ngIf="!isGDO" class="faqs-section font-16 red-color">
  <div>
    <!-- <p> -->
    <p class="font-14 red-color">Need Help?</p>
    <!-- </p> -->

    <p></p>
    <div *ngIf="!isAcura">
      <p class="font-14 black-color zero-padding"><b>Honda Vehicles</b></p>

      <a class="font-12 black-color zero-padding underline"
        href="{{myGarageHost}}/s/article/HondaLink-Frequently-Asked-Questions-H?brand=HondaLinkFAQs"
        (click)="onLinkClick()" target="_blank">HondaLink FAQs</a>
      <p></p>
      <a class="font-12 black-color zero-padding underline" (click)="onLinkClick()"
        href="{{myGarageHost}}/s/help-center-honda" target="_blank">Honda Autos Help Articles & FAQs</a>
      <p></p>
      <p class="font-12 black-color zero-padding font-weight-500">Contact Us</p>

      <p class="font-12 grey-color zero-padding">
        Monday - Friday
        <br>
        6:00 AM - 5:00 PM PT
      </p>
      <p class="font-12 black-color zero-padding font-weight-500">+1 (888) 528-7876</p>
      <!-- <p class="font-12 black-color zero-padding font-weight-500">Chat with Us</p> -->
    </div>

    <div *ngIf="isAcura">
      <p class="font-14 black-color zero-padding font-weight-500">Acura Vehicles</p>

      <a class="font-12 black-color zero-padding underline" (click)="onLinkClick()"
        href="{{myGarageHost}}/s/article/Acura1-What-is-AcuraLink?brand=AcuraLinkFAQs" target="_blank">Acura
        FAQs</a>
      <p></p>
      <a class="font-12 black-color zero-padding underline" (click)="onLinkClick()"
        href="{{myGarageHost}}/s/help-center-acura" target="_blank">Acura Autos Help Articles & FAQs</a>
      <p></p>
      <p class="font-12 black-color zero-padding font-weight-500">Contact Us</p>

      <p class="font-10 grey-color zero-padding">
        Monday - Friday
        <br>
        6:00 AM - 5:00 PM PT
      </p>
      <p class="font-12 black-color zero-padding font-weight-500">+1 (888) 528-7876</p>
      <!-- <p class="font-12 black-color zero-padding font-weight-500">Chat with Us</p> -->
    </div>

  </div>
</div>


<!-- If Gdo -->
<div *ngIf="isGDO" class="faqs-section font-16 red-color">
  <div>
    <!-- <p> -->
    <p class="font-14 red-color">Need Help?</p>
    <!-- </p> -->

    <p></p>
    <div *ngIf="!isAcura">
      <p class="font-14 black-color zero-padding"><b>myQ Connected Garage</b></p>

      <a class="font-12 black-color zero-padding underline"
        href="{{myGarageHost}}/s/article/HondaLink-Frequently-Asked-Questions-H?brand=HondaLinkFAQs"
        (click)="onLinkClick()" target="_blank">FAQs</a>
      <p></p>
      <a class="font-12 black-color zero-padding underline" (click)="onLinkClick()"
        href="{{myGarageHost}}/s/help-center-honda" target="_blank">myQ Compatibility Tool</a>
      <p></p>
      <p class="font-12 black-color zero-padding font-weight-500">Contact Us</p>

      <p class="font-12 grey-color zero-padding">
        Monday - Friday
        <br>
        6:00 AM - 5:00 PM PT
      </p>
      <p class="font-12 black-color zero-padding font-weight-500">+1 (888) 528-7876</p>
      <!-- <p class="font-12 black-color zero-padding font-weight-500">Chat with Us</p> -->
    </div>

    <div *ngIf="isAcura">
      <p class="font-14 black-color zero-padding font-weight-500">Acura Vehicles</p>

      <a class="font-12 black-color zero-padding underline" (click)="onLinkClick()"
        href="{{myGarageHost}}/s/article/Acura1-What-is-AcuraLink?brand=AcuraLinkFAQs" target="_blank">Acura
        FAQs</a>
      <p></p>
      <a class="font-12 black-color zero-padding underline" (click)="onLinkClick()"
        href="{{myGarageHost}}/s/help-center-acura" target="_blank">Acura Autos Help Articles & FAQs</a>
      <p></p>
      <p class="font-12 black-color zero-padding font-weight-500">Contact Us</p>

      <p class="font-10 grey-color zero-padding">
        Monday - Friday
        <br>
        6:00 AM - 5:00 PM PT
      </p>
      <p class="font-12 black-color zero-padding font-weight-500">+1 (888) 528-7876</p>
      <!-- <p class="font-12 black-color zero-padding font-weight-500">Chat with Us</p> -->
    </div>

  </div>
</div>